<div class="d-flex flex-row-reverse mb-0 mt-2">
    <button (click)="onCancelClick()" (keyup.enter)="onCancelClick()"
      class="btn btn-lg btn-default ms-3" translate>common-buttons.cancel
    </button>
    <button  (click)="onSaveClick()" (keyup.enter)="onSaveClick()" class="btn btn-lg btn-primary"
    [disabled]='disableSaveButton'
      translate>common-buttons.save
    </button>
</div>
